export default __webpack_public_path__ + "static/media/Home-central.a2eda600.png";